import Vue from 'vue';
import store from './../../store';
import teamMemberService from "./index";
import attachTeamMember from "./attachTeamMember";

// When the request succeeds
const success = (response, context) => {
  if (response && response.data && response.data.user) {
    let userEmail = response.data.user.email;
    swal({
        title: userEmail + ' ' + context.$t("account.users.teamMember.existsAccount"),
        text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>"'+context.$t("account.users.teamMember.addTeamMember")+'"</div>',
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: 'Yes, add it!',
        closeOnConfirm: false,
        html: true
      },
      function() {
        $(".cancel").addClass("disabled");
        $(".confirm").addClass("disabled");
        $(".pulseWarning").hide();
        $("#loading1").show();
        teamMemberService.attachTeamMember(response.data.user, response.data.rights,  this);
      });
    Vue.router.push({
      name: 'new.user.create',
    });
    context.loading = false;
  } else {
    Vue.router.push({
      name: 'account.team',
    });
    context.loading = false;
    toastr.success(response.data.msg);
  }
};

// When the request fails
const failed = (error, context) => {
    context.showToasterError(error);
    context.loading = false;
};

export default (member, context) => {
    return Vue.$http.post('/team-members', member)
        .then((response) => {
          if (response && response.status === 200) {
                success(response, context);
            } else {
                failed();
            }
        })
        .catch((error) => {
            failed(error, context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/team_member/storeTeamMember.js